import ActionsDropdown, { Action } from '@anm/components/ActionsDropdown';
import { DropdownContent, DropdownDirections } from '@anm/components/Dropdown';
import SocialAvatar from '@anm/components/SocialAvatar';
import ShareDialog from '@anm/components/share/ShareDialog';
import { CUSTOMIZE_WEBINAR_ROUTE } from '@anm/constants/routes';
import { getDropdownAction } from '@anm/helpers/dropdownActions';
import getFromCdn from '@anm/helpers/getFromCdn';
import isMobile from '@anm/helpers/is/isMobile';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useState, FC, MouseEvent } from 'react';
import styled from 'styled-components';
import configs from 'video-templates/config';

export const WebinarDestinationWrapper = styled.div`
  z-index: 10;
  position: relative;

  ${DropdownContent} {
    left: 50%;
    width: fit-content;
    transform: translateX(-50%);
  }
`;

export type WebinarDestinationProps = {
  webinarId?: string;
};

const { urls } = configs();

const WebinarDestination: FC<WebinarDestinationProps> = ({ webinarId }) => {
  const [direction, setDirection] = useState<DropdownDirections>('to-bottom-no-arrow-static');

  const [isShare, , , toggleShareModal] = useSwitchState();

  const webinarLink = `${urls.webinarUrl}${webinarId}`;

  const actions: Action[] = [
    {
      ...getDropdownAction('onEdit'),
      name: 'Customize Webinar',
      href: `/${CUSTOMIZE_WEBINAR_ROUTE}/${webinarId}`
    },
    {
      name: 'Open Webinar page',
      icon: getFromCdn('images/icons/webinar-page-ic.svg'),
      href: webinarLink
    },
    {
      ...getDropdownAction('onShare'),
      name: 'Share Webinar',
      handler: toggleShareModal
    }
  ];

  const handelMouseEnter = (evt: MouseEvent<HTMLDivElement>) => {
    const { bottom } = (evt.target as Element).getBoundingClientRect();

    const canOpenToTop = window.innerHeight - bottom < actions.length * 45 + 20;

    const newDirection = canOpenToTop ? 'to-top-center' : 'to-bottom-no-arrow-static';
    setDirection(newDirection);
  };

  return (
    <WebinarDestinationWrapper onMouseEnter={handelMouseEnter}>
      {isShare && (
        <ShareDialog
          isServices={false}
          shareLink={webinarLink}
          title="Share webinar"
          description="Copy the link below and send it to your audience"
          onClose={toggleShareModal}
        />
      )}
      <ActionsDropdown actions={actions} openerVariant="default" direction={isMobile() ? 'to-top' : direction}>
        <SocialAvatar
          network="WEBINAR"
          variant="50x50"
          alt="webinar destination"
          avatarSrc={getFromCdn('images/icons/webinar-destination.svg')}
        />
      </ActionsDropdown>
    </WebinarDestinationWrapper>
  );
};

export default WebinarDestination;
